import React from 'react';
import { FileSearch, Shield, Award } from 'lucide-react';
import { qualityData } from '../data/mock';

const iconMap = {
  FileSearch: FileSearch,
  Shield: Shield,
  Award: Award,
};

const QualitySection = () => {
  return (
    <section id="quality" className="py-24 md:py-32 bg-black">
      <div className="container mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="max-w-4xl mb-16 md:mb-20">
          <span className="text-gray-500 text-sm uppercase tracking-widest font-medium mb-4 block">
            {qualityData.subtitle}
          </span>
          <h2 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight uppercase">
            {qualityData.title}
          </h2>
        </div>

        {/* Standards Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {qualityData.standards.map((standard, index) => {
            const IconComponent = iconMap[standard.icon];
            return (
              <div
                key={index}
                className="group border border-gray-800 hover:border-white p-8 md:p-10 transition-all duration-300"
              >
                {/* Icon */}
                <div className="mb-8">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-white text-black group-hover:scale-105 transition-transform duration-300">
                    {IconComponent && (
                      <IconComponent className="w-10 h-10" strokeWidth={1.5} />
                    )}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-white text-xl font-bold uppercase tracking-wide mb-4">
                  {standard.title}
                </h3>

                {/* Description */}
                <p className="text-gray-500 leading-relaxed">
                  {standard.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Video Section */}
        <div className="mt-24 pt-16 border-t border-gray-800">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-white text-2xl md:text-3xl font-bold uppercase tracking-wide mb-8 text-center">
              Tanıtım Videosu
            </h3>
            <div className="relative aspect-video bg-gray-900">
              <iframe
                src="https://www.youtube.com/embed/YS-C5JXiCdk"
                title="AR Tarım Tanıtım Videosu"
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;
